import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#00e676",
        secondary: "#18191c",
        accent: "#00e676",
        dark: "#111215",
      },
    },
  },
});
